import React from 'react';

import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Listing, ListingHeader } from 'common-ui/containers';
import { dealBaseApi, useAppSelector } from 'core/lib';
import { selectFilteredListing } from 'core/lib/modules/dealBase/store';
import { DealBaseListingHeaderActions, DealBaseListingHeaderNavigation } from 'modules/dealBase/components';
import { Routes } from 'routes/routes';
import LoaderWrapper from 'utils/loader-wrapper';

import DealBaseDashboard from '../dashboard';
import DealBaseListing from '../listing';

const ListingContainer = () => {
  const { t } = useTranslation();
  const { data, isFetching } = dealBaseApi.useGetDealBaseListingQuery();

  const listingData = useAppSelector((state) => selectFilteredListing(state, data));

  return (
    <Switch>
      <LoaderWrapper loading={isFetching} message={t('loaders:dealBase.loadingListing')}>
        <ListingHeader
          count={listingData?.length ?? 0}
          title={t('global:moduleNames.dealbase')}
          extra={[
            <DealBaseListingHeaderNavigation key="headerNavigation" />,
            <DealBaseListingHeaderActions key="listingActions" />,
          ]}
        />
        <Listing>
          <Switch>
            <Route
              path={Routes.DEAL_BASE_LISTING.path}
              exact
              render={() => <DealBaseListing listingData={listingData} />}
            />
            <Route
              path={Routes.DEAL_BASE_DASHBOARD.path}
              exact
              render={() => <DealBaseDashboard listingData={listingData} />}
            />
            <Redirect to={Routes.DEFAULT.path} />
          </Switch>
        </Listing>
      </LoaderWrapper>
    </Switch>
  );
};

export default ListingContainer;
